define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/DomainModel", "../../models/UserContext"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, DomainModel, UserContext) {
    "use strict";
    var Domains = /** @class */ (function () {
        function Domains() {
            this.userCanEdit = ko.observable(UserContext.hasAccess("Admin,Domains.Edit,Domains.Delete"));
            this.userCanDelete = ko.observable(UserContext.hasAccess("Admin,Domains.Delete"));
            this.editModel = ko.observable(new DomainModel());
            this.clearFilterInProgress = false;
            this.filterByAny = ko.observable("");
        }
        Domains.prototype.init = function () {
            var self = this;
            $("#page-title").text("Domains");
            tools.ajaxGet({
                url: "/Domains/GetDomainsLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initDomains(self.lookupLists.GridStructures.DomainStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        Domains.prototype.initDomains = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "100px",
                sortable: false,
                template: function (dataItem) {
                    var html = "";
                    if (self.userCanEdit()) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i></a>';
                    }
                    if (self.userCanDelete()) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            });
            var gridId = "domainTable";
            self.domainTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                gridOptions: {
                    columns: columns,
                    autoBind: true,
                    resizable: true,
                    //reorderable: true,
                    //mobile: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row menu",
                        extra: false
                    }
                },
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Domains/GetDomains",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total"
                    }
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "Domain",
                    title: "Domains",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.domainTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.domainTable.refresh();
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.editDomain(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.deleteDomainConfirm(data.Id, data.Name);
                event.preventDefault();
            });
        };
        Domains.prototype.editDomain = function (id) {
            var self = this;
            var title = id > 0 ? "Edit Domain" : "Add Domain";
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.saveDomain(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/Domains/GetDomainById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new DomainModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new DomainModel());
                    }
                    $.when(getModelCall).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'domain-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        Domains.prototype.saveDomain = function (btn, modal) {
            var _this = this;
            var self = this;
            var obj = ko.mapping.toJS(self.editModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Domains/SaveDomain",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    _this.domainTable.refresh();
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        Domains.prototype.deleteDomainConfirm = function (id, name) {
            var self = this;
            tools.confirmModal({
                title: "Delete Domain",
                text: 'Are you sure you want to delete domain "' + name + '"?',
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteDomain(id);
            });
        };
        Domains.prototype.deleteDomain = function (id) {
            var self = this;
            var data = {
                id: id
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Domains/DeleteDomainConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Domain deleted successfully");
                    self.domainTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        Domains.prototype.clearFilter = function () {
            var self = this;
            self.filterByAny("");
        };
        Domains.prototype.exportTo = function () {
            var self = this;
            self.domainTable.exportTo();
        };
        Domains.prototype.initLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("Domain");
                dataLogs.initKendoLogs("divLogsTable");
            }
        };
        return Domains;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Domains/Index")) {
            log.log("Initialize Domains");
            $(function () {
                (new Domains()).init();
            });
        }
    }, 0);
    return Domains;
});
//# sourceMappingURL=domains.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/settings/domains.js
// module id = 232
// module chunks = 2